module.exports = __webpack_public_path__ + "static/media/INZ1113.2ce4c40a.pdf";